import BaseService from '../BaseService';

class PromotionService extends BaseService {
    getAll = (filters) => this.post('/warehouse/report/promotion', filters || { });
}

export default new PromotionService();